import React from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Spinner.css";

export default function Spinner() {
  return (
    <div className="h-50 d-flex justify-content-center align-items-center spinner">
      <FontAwesomeIcon icon={faSpinner} size="2x" spin />
    </div>
  );
}
